<div class="change-preview-container">
    <div class="preview-header mb-3">
        <h6 class="mb-0 text-primary font-weight-bold">
            <i class="pi pi-diff mr-2"></i> Review Your Changes
        </h6>
        <p class="text-muted small mb-0">The following modifications have been detected.</p>
    </div>

    <div *ngIf="hasChanges; else noChanges">
        <!-- Tab Navigation -->
        <div class="custom-tabs mb-4 pb-2 border-bottom" *ngIf="tabs.length > 1">
            <ul class="nav nav-pills nav-fill">
                <li class="nav-item" *ngFor="let tab of tabs; let i = index">
                    <a class="nav-link font-weight-bold" [class.active-pill]="activeTabIndex === i" href="javascript:void(0)" (click)="activeTabIndex = i">
                        {{ tab.tabLabel }}
                        <span class="badge badge-light ml-1" *ngIf="(tab.fields.length + tab.arrays.length) > 0">
                            {{ tab.fields.length + tab.arrays.length }}
                        </span>
                    </a>
                </li>
            </ul>
        </div>

        <!-- Tab Content -->
        <div class="tab-content">
            <div class="tab-pane active" *ngFor="let tab of tabs; let i = index" [hidden]="activeTabIndex !== i">
                
                <!-- Fields Diff -->
                <div class="diff-list" *ngIf="tab.fields.length > 0">
                    <h6 class="section-title text-muted mb-3"><i class="pi pi-list mr-2"></i>Field Changes</h6>
                    <div class="diff-item card border-0 mb-3 shadow-sm" *ngFor="let field of tab.fields">
                        <div class="card-body p-3">
                            <div class="field-header d-flex justify-content-between align-items-center mb-2">
                                <div class="field-label">{{ field.label }}</div>
                                <span class="badge" 
                                      [ngClass]="{'badge-success': field.status === 'added', 'badge-warning': field.status === 'updated', 'badge-danger': field.status === 'deleted'}">
                                    {{ field.status | uppercase }}
                                </span>
                            </div>
                            
                            <div class="diff-grid" *ngIf="field.status !== 'added'">
                                <div class="diff-box old-box" [class.w-100]="field.status === 'deleted'">
                                    <div class="box-label">Old Value</div>
                                    <div class="box-content strikethrough">{{ field.oldValue }}</div>
                                </div>
                                <div class="diff-arrow" *ngIf="field.status === 'updated'">
                                    <i class="pi pi-arrow-right"></i>
                                </div>
                                <div class="diff-box new-box" *ngIf="field.status === 'updated'">
                                    <div class="box-label">New Value</div>
                                    <div class="box-content">{{ field.newValue }}</div>
                                </div>
                            </div>
                            <div class="diff-grid" *ngIf="field.status === 'added'">
                                <div class="diff-box new-box w-100">
                                    <div class="box-label">New Value</div>
                                    <div class="box-content">{{ field.newValue }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Array Diff -->
                <div class="array-diff-list mt-4" *ngFor="let arr of tab.arrays">
                    <h6 class="section-title text-muted mb-3"><i class="pi pi-table mr-2"></i>{{ arr.label }} Changes</h6>
                    
                    <!-- Added Rows -->
                    <div class="alert custom-alert-success border-0 mb-3 shadow-sm" *ngIf="arr.addedRows.length > 0">
                        <div class="font-weight-bold mb-2 text-success"><i class="pi pi-plus-circle mr-2"></i> {{ arr.addedRows.length }} Row(s) Added</div>
                        <ul class="mb-0 pl-3">
                            <li *ngFor="let row of arr.addedRows" class="small py-1 text-dark">
                                {{ formatRowPreview(row) }}
                            </li>
                        </ul>
                    </div>

                    <!-- Deleted Rows -->
                    <div class="alert custom-alert-danger border-0 mb-3 shadow-sm" *ngIf="arr.deletedRows.length > 0">
                        <div class="font-weight-bold mb-2 text-danger"><i class="pi pi-minus-circle mr-2"></i> {{ arr.deletedRows.length }} Row(s) Deleted</div>
                        <ul class="mb-0 pl-3 text-dark">
                            <li *ngFor="let row of arr.deletedRows" class="small py-1 strikethrough opacity-75">
                                {{ formatRowPreview(row) }}
                            </li>
                        </ul>
                    </div>

                    <!-- Updated Rows -->
                    <div *ngIf="arr.updatedRows.length > 0">
                        <div class="font-weight-bold mb-2 text-warning"><i class="pi pi-pencil mr-2"></i> Updated Rows</div>
                        <div class="diff-item card border-0 mb-3 shadow-sm" *ngFor="let row of arr.updatedRows">
                            <div class="card-header bg-light border-0 py-2">
                                <span class="font-weight-bold small text-muted">Row ID/Idx: {{ row.id }}</span>
                            </div>
                            <div class="card-body p-3">
                                <div class="mb-3 border-bottom pb-2 last-no-border" *ngFor="let field of row.changes">
                                    <div class="field-header d-flex justify-content-between align-items-center mb-1">
                                        <div class="field-label small">{{ field.label }}</div>
                                        <span class="badge" 
                                              [ngClass]="{'badge-success': field.status === 'added', 'badge-warning': field.status === 'updated', 'badge-danger': field.status === 'deleted'}">
                                            {{ field.status | uppercase }}
                                        </span>
                                    </div>
                                    <div class="diff-grid align-items-center mt-2">
                                        <div class="diff-box old-box py-1 px-2 flex-grow-1" *ngIf="field.status !== 'added'">
                                            <div class="box-content strikethrough small">{{ field.oldValue }}</div>
                                        </div>
                                        <div class="diff-arrow mx-2" *ngIf="field.status === 'updated'">
                                            <i class="pi pi-arrow-right" style="font-size: 0.8rem;"></i>
                                        </div>
                                        <div class="diff-box new-box py-1 px-2 flex-grow-1" *ngIf="field.status !== 'deleted'">
                                            <div class="box-content small">{{ field.newValue }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    </div>

    <ng-template #noChanges>
        <div class="text-center py-5">
            <i class="pi pi-check-circle text-success mb-3" style="font-size: 2.5rem;"></i>
            <h5 class="font-weight-bold text-dark">No Data Modifed</h5>
            <p class="text-muted small">The current form values are identical to the original record.</p>
        </div>
    </ng-template>
</div>
